import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=4c647a2f&scoped=true&lang=pug"
import script from "./NewsArticle.vue?vue&type=script&lang=js"
export * from "./NewsArticle.vue?vue&type=script&lang=js"
import style0 from "./NewsArticle.styl?vue&type=style&index=0&id=4c647a2f&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c647a2f",
  null
  
)

export default component.exports